<div class="card card--box" >
    <app-breadcrumb (click)="patientService.activeTab = TABHEADER.OVERVIEW;"></app-breadcrumb>
</div>
<div class="patient-header-nav tab-container">
    <ul class="nav nav-tabs">
        <li class="nav-item" (click)="selectTabHeader(TABHEADER.OVERVIEW)" [class.active]="patientService.activeTab === TABHEADER.OVERVIEW">
            <a class="nav-link" [class.active]="patientService.activeTab === TABHEADER.OVERVIEW" href="javascript:void(0);">
                <span>{{ 'Overview header' | translate }}</span>
            </a>
        </li>
        <li *ngIf="haveAccessPatient()" class="nav-item" (click)="selectTabHeader(TABHEADER.SR)" [class.active]="patientService.activeTab === TABHEADER.SR">
            <a class="nav-link" [class.active]="patientService.activeTab === TABHEADER.SR" href="javascript:void(0);">
                <span>{{ 'Self Evaluation' | translate }}</span>
            </a>
        </li>
        <li *ngIf="haveAccessPatient()" class="nav-item" (click)="selectTabHeader(TABHEADER.CV)" [class.active]="patientService.activeTab === TABHEADER.CV">
            <a class="nav-link" [class.active]="patientService.activeTab === TABHEADER.CV" href="javascript:void(0);">
                <span>{{ 'Diagnostic Interview' | translate }}</span>
            </a>
        </li>
        <li *ngIf="haveAccessPatient()" class="nav-item" (click)="selectTabHeader(TABHEADER.PROPOSALS)" [class.active]="patientService.activeTab === TABHEADER.PROPOSALS">
            <a class="nav-link" [class.active]="patientService.activeTab === TABHEADER.PROPOSALS" href="javascript:void(0);">
                <span>{{ 'Diagnosis' | translate }}</span>
            </a>
        </li>
        <li *ngIf="haveAccessPatient() && isShowPatientDocument && patient['user_patient_id']" class="nav-item" (click)="selectTabHeader(TABHEADER.DOCUMENTS)" [class.active]="patientService.activeTab === TABHEADER.DOCUMENTS">
            <a class="nav-link" [class.active]="patientService.activeTab === TABHEADER.DOCUMENTS" href="javascript:void(0);">
                <span>{{ 'Documents' | translate }}</span>
            </a>
        </li>
        <li class="nav-item" (click)="selectTabHeader(TABHEADER.SUICIDALITY)" [class.active]="patientService.activeTab === TABHEADER.SUICIDALITY">
            <a class="nav-link" [class.active]="patientService.activeTab === TABHEADER.SUICIDALITY" href="javascript:void(0);">
                <span>{{ 'Info Video-Call' | translate }}</span>
            </a>
        </li>

    </ul>
    <div class="tab-content">
        <div class="full-width" [class.full-height]="patientService.activeTab !== TABHEADER.OVERVIEW">
            <div *ngIf="patient && patient['id']" class="patient-overview" [class.hidden]="patientService.activeTab !== TABHEADER.OVERVIEW">
                <div class="container">
                    <div class="row">
                        <div class="col-xs-4 patient-overview__infor">
                            <div class="identity">
                                <div class="identity__name">
                                    {{ patient['surname'] }}  {{ patient['name'] }}
                                </div>
                                <div class="identity__birthday">
                                    <span class="identity__birthday--label">{{ 'Entry' | translate }} : </span>
                                    <span class="identity__birthday--text">{{ patient['entry_date'] }}</span>
                                </div>
                                <div class="identity__status patient-status">
                                    <span class="badge badge-pill {{ patientsService.getStatus(patient) }} mr-1 ellipsis">
                                        {{ patientsService.getprofileStatus(patient['latest_action'].template) | translate: patient['latest_action'].params }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-8 patient-overview__action">
                            <div class="row">
                                <div class="col-xs-12">
                                    <app-patient-menu-action
                                        [patient]="patient"
                                        [isProfile]="true"
                                        [type]="'patient_profile'"
                                        [userRoleId] = "authService.user['role_id']"
                                        (exportMap)="exportMap($event)"
                                        (openSEModal)="openSEModal($event)"
                                        (openDI)="openDI()"
                                        (openEditModal)="openEditPatientFormModal(patient.id)"
                                        (openModal)="initModalForm($event)"
                                        (requestAccess)="requestAccessHealthData(patient)"
                                        [appService]="appService"
                                    >
                                    </app-patient-menu-action>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-3 identity">
                                    <div class="identity__header">
                                        {{ 'Date of Birth' | translate }}
                                    </div>
                                    <div class="identity__body">
                                        {{ patient['birthday'] }}
                                    </div>
                                </div>
                                <div class="col-xs-2 identity">
                                    <div class="identity__header">
                                        {{ 'Age' | translate }}
                                    </div>
                                    <div class="identity__body" *ngIf="patient['age'] > 1">
                                        {{ patient['age'] | number: '1.0-0' }}
                                    </div>
                                </div>
                                <div class="col-xs-2 identity">
                                    <div class="identity__header">
                                        {{ 'Sex' | translate }}
                                    </div>
                                    <div class="identity__body">
                                        {{ patient['gender_text'] | translate }}
                                    </div>
                                </div>
                                <div class="col-xs-5 identity" *ngIf="patient['has_permission'] === patientService.ACCESSSTATUS['GRANTED']">
                                    <div class="identity__header">
                                        {{ 'Context' | translate }}
                                    </div>
                                    <div class="identity__body">
                                        {{ patient['context'] }}
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-3 identity">
                                    <div class="identity__header">
                                        {{ 'Patient Nr' | translate }}
                                    </div>
                                    <div class="identity__body">
                                        {{ patient['number'] }}
                                    </div>
                                </div>
                                <div class="col-xs-2 identity">
                                    <div class="identity__header">
                                        {{ 'Language' | translate }}
                                    </div>
                                    <div class="identity__body">
                                        {{ patient['language']['name'] | translate }}
                                    </div>
                                </div>
                                <div class="col-xs-2 identity">
                                    <div class="identity__header">
                                        {{ 'Res. ID' | translate }}
                                    </div>
                                    <div class="identity__body">
                                        {{ patient['id'] }}
                                    </div>
                                </div>
                                <div class="col-xs-5 identity" *ngIf="patient['difficulties'] && patient['difficulties'] != '' && patient['has_permission'] === patientService.ACCESSSTATUS['GRANTED']">
                                    <div class="identity__header">
                                        {{ 'Difficulties' | translate }}
                                    </div>
                                    <div class="identity__body">
                                        {{ patient['difficulties'] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container" [class.hidden]="patientService.activeTab !== TABHEADER.OVERVIEW">
                <app-patient-questionnaires
                    #questionnairesComponent
                    [items]="questionnaires"
                    [patient]="patient"
                    [id]="id"
                    [role]="userRole"
                    [tabs]="TABHEADER"
                    (action)="selectedQuestionnaire=$event.questionnaire;selectTabHeader($event.action)">
                </app-patient-questionnaires>
            </div>
            <div *ngIf="haveAccessPatient() && questionnaireData" class="container" [class.hidden]="patientService.activeTab !== TABHEADER.OVERVIEW">
                <app-patient-selected-diagnoses
                        *ngIf="getDiagnosisData && patientService.activeTab === TABHEADER.OVERVIEW"
                        (openProposalDiagnosis)="openProposalDiagnosis($event)"
                        [patientId]="id"
                        [items]="questionnaires"
                        [lastestQuestionnaire]="questionnaireData"></app-patient-selected-diagnoses>
            </div>
            <app-symptom-map-component
                #seMap
                [class.hidden]="patientService.activeTab !== TABHEADER.SR"
                [questionnairesComponent]="questionnairesComponent"
                symptomMapId="SE"
                (enableComparison)="enableComparison($event)"
                [patientId]="id"
                [getDiagnosisData]="getDiagnosisData"
                [patientSurname]="patient['surname']"
                [patientName]="patient['name']"
                [currentDates]="seCompletedDates"
                [completedDates]="completedDates"
                [selectedSymptomMap]="selectedSymptomMap"
                [collapseDiagnoses]="collapseDiagnoses"
                (scrollToMap)="scrollToMap()"
                (changePatientTab)="selectTabHeader($event)"
                (disableDiagnoses)="disableDiagnoses($event)"
                (enableEditMode)="enableEditMode($event)">
            </app-symptom-map-component>
            <app-symptom-map-component
                #diMap
                [class.hidden]="patientService.activeTab !== TABHEADER.CV && patientService.activeTab !== TABHEADER.PROPOSALS"
                [questionnairesComponent]="questionnairesComponent"
                symptomMapId="DI"
                [getDiagnosisData]="getDiagnosisData"
                [isViewOnly]="false"
                (enableComparison)="enableComparison($event)"
                [patientId]="id"
                [patientSurname]="patient['surname']"
                [patientName]="patient['name']"
                [currentDates]="diCompletedDates"
                [completedDates]="completedDates"
                [selectedSymptomMap]="selectedSymptomMap"
                [collapseDiagnoses]="collapseDiagnoses"
                (scrollToMap)="scrollToMap()"
                (changePatientTab)="selectTabHeader($event)"
                (disableDiagnoses)="disableDiagnoses($event)"
                (enableEditMode)="enableEditMode($event)">
            </app-symptom-map-component>

            <proposal-diagnosis-component *ngIf="triggerOpenProposalDiagnosis"
                                            #diagnosisComponent
                                            [isCollapsed]="!triggerOpenProposalDiagnosis"
                                            [nodeClassList]="(symptomNode && isComparisonViewMode && activeItem.type === 'comparison')? symptomNode.classList : []"
                                            [diagnosesProposal]="patientService.proposalData"
                                            [mapData]="diMap.interactiveMapComponent ? diMap.interactiveMapComponent.mapData : []"
                                            [patientId]="id"
                                            [isDisabled]="!triggerOpenProposalDiagnosis"
                                            [symptomMapId]="questionnaireData['id']"
                                            [isFullScreen]="isFullScreen"
                                            [overviewDiagnosis]="true"
                                            (closeProposalDiagnosis)="triggerOpenProposalDiagnosis=false">
            </proposal-diagnosis-component>

            <div *ngIf="patient && patient['id'] && isShowPatientDocument" class="full-width" [class.hidden]="patientService.activeTab !== TABHEADER.DOCUMENTS">
                <div class="container mr-b--md mr-t--md">
                    <div class="box-shadow">
                        <div class="card card--box">
                            <div class="card--box__header">
                                <div class="card--box__header--info">
                                    <div class="card--box__header__title help-btn">
                                        <div class="card--box__header__title help-btn">
                                            <h2>
                                                {{ 'Documents' | translate }}
                                            </h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table--grid email-template-table">
                            <div class="table--grid__body">
                                <div class="row">
                                    <div class="col-xs-2 offset-xs-10 pull-right fileInputProfileWrap mr-t--sm">
                                        <input id="imageUpload" type="file" (change)="fileChangeEvent($event)"
                                               class="fileInputProfile hidden"/>
                                        <label for="imageUpload" class="btn btn-primary btn-upload pull-right">{{
                                            'Upload file' | translate }}</label>
                                        <div *ngIf="pdf && pdf.pdf && pdf.pdf_url" class="mr-t--sm">
                                                <span>{{ 'PDF' | translate }} :
                                                    <a href="{{ pdf.pdf_url }}" target="_blank" rel="noopener"> {{ pdf.pdf }}</a>
                                                </span>
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="documents && documents.length; else empty" class="example-list">
                                    <div class="row example-box" *ngFor="let pdf of documents">
                                        <div class="col-xs-11 col-lg-11">
                                            <div class="row">
                                                <div class="col-xs-8 col-lg-8">
                                                    <span>
                                                       {{ pdf['original_file_name']}}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xs-4 col-lg-4 table--grid__actions table--grid__actions--hover">
                                            <ul class="list-inline">
                                                <li class="list-inline-item" (click)="documentConfirmModal({
                                                        url: 'patient/document',
                                                        id: pdf['id'],
                                                        action: 'delete',
                                                        title: 'Delete PDF',
                                                        content: 'Are you sure you want to delete this PDF?',
                                                        icon: 'far fa-trash-alt'
                                                    })">
                                                    <a class="btn btn-link table--grid__action-btn">
                                                        <i class="far fa-trash-alt table--grid__actions__links__icon"
                                                           aria-hidden="true"></i>
                                                    </a>
                                                </li>
                                                <li class="list-inline-item" (click)="dowloadDocument(pdf)">
                                                    <a class="btn btn-link table--grid__action-btn">
                                                        <i class="far fa-download table--grid__actions__links__icon"
                                                           aria-hidden="true"></i>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <ng-template #empty>
                                    <div class="text-xs-center pd-v--sm">
                                        {{ 'No PDF documents have been uploaded for this patient yet.' | translate }}
                                    </div>
                                </ng-template>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="patient && patient['id'] && isShowPatientServiceProvider" class="full-width" [class.hidden]="patientService.activeTab !== TABHEADER.THERAPY">
                <div class="container">
                    <app-patient-selected-diagnoses
                            *ngIf="getDiagnosisData && patientService.activeTab === TABHEADER.THERAPY"
                            (openProposalDiagnosis)="openProposalDiagnosis($event)"
                            [patientId]="id"
                            [viewOnly]="true"
                            [items]="questionnaires"
                            [lastestQuestionnaire]="questionnaireData"></app-patient-selected-diagnoses>

                    <app-therapy-offers
                            [documents]="documents"
                            [patientId]="id"
                            [questionnaireData]="questionnaireData"
                            (navigateDocumentTab)="autoGenerateReport($event)"
                            [questionnaires]="questionnaires">
                    </app-therapy-offers>
                </div>
            </div>

            <div *ngIf="patient && patient['id'] && patientService.activeTab === TABHEADER.SUICIDALITY" class="full-width">
                <div class="container">
                    <app-suicidality
                            [documents]="documents"
                            [patientId]="id"
                            [questionnaireData]="questionnaireData"
                            (navigateDocumentTab)="autoGenerateReport($event)"
                            [questionnaires]="questionnaires">
                    </app-suicidality>
                </div>
            </div>
        </div>
    </div>
</div>

<div>
    <!-- DIRECTIVE FOR EDIT PATIENT -->
    <div bsModal #modal="bs-modal" class="modal patient-creation-modal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog">
            <app-patients-modal [params]="params" [formLoading]="externalFormLoading" [patientForm]="externalForm" [patient]="patient"
                [errorMessage]="errorMessage" [successMessage]="successMessage" [mpa]="mpa"
                [doctors]="doctors" [assistants]="assistants"
                [authService]="authService" [createSEout]="createSE"
                [token]="token" [languages]="languages" (hideModal)="hideModal(false)"
                (submitPatientWithSE)="savePatientWithSE(externalForm.value, externalForm.valid)"
                (submitPatient)="savePatient(externalForm.value, externalForm.valid)">
            </app-patients-modal>
        </div>
    </div>

    <!--    CONFIRMATION TO ARCHIVE CURRENT QUESTIONNAIRE -->
    <div bsModal #modalArchive="bs-modal" class="modal fade modal-confirmation" tabindex="-1" role="dialog" aria-hidden="true">
        <!-- archive || delete -->
        <div *ngIf="params['action'] === 'archive'" class="modal-dialog modal-confirmation-dialog modal-sm">
            <div class="modal-content">
                <div class="modal-body text-xs-center">
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="modal-icon">
                                <i *ngIf="params['action'] === 'archive'" class="fas fa-archive" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                    <confirm-modal-body [responseMessage]="responseMessage" [params]="params"></confirm-modal-body>
                    <div class="row">
                        <input (change)="showArchiveMessageFuture = !showArchiveMessageFuture" type="checkbox" id="continous-showing" [checked]="!showArchiveMessageFuture" />
                        <label for="continous-showing">{{ 'Do not show this information in the future' | translate }}</label>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 text-xs-right">
                            <button *ngIf="!responseMessage" type="button" class="btn btn-primary" (click)="archiveQuestionnaires()">
                                {{ 'OK' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- CREATE SE MODAL-->
    <router-outlet></router-outlet>

    <div bsModal #modalDiagnosis="bs-modal" class="modal fade diagnosis-notify-modal modal-confirmation" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-md modal-confirmation-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {{ 'Did you know?' | translate }}
                </h4>
                <button (click)="hideDiagnosisModal(false)" class="fal fa-times close" aria-label="Close" type="button"></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-sm-12">
                        {{ 'manual diagnosis pop up content' | translate }}
                    </div>
                </div>
                <div>&nbsp;</div>
                <div class="row">
                    <div class="col-sm-12">
                        <button class="btn btn-primary" (click)="gotoCV()" type="button">{{ 'Go to Clinical Validation' | translate}}</button>&nbsp;&nbsp;
                        <button class="btn btn-dismiss" (click)="hideDiagnosisModal(true)" type="button">{{ 'Dismiss' | translate}}</button>
                    </div>
                </div>
                <div>&nbsp;</div>
                <div class="row">
                    <div class="form-group col-xs-12">
                        <input [(ngModel)]="dismissDiagnosis" type="checkbox" id="dismiss-diagnosis"/>
                        <label for="dismiss-diagnosis">{{ 'Dismiss all future suggestions' | translate }}</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</div>

<dialog-component #dialog></dialog-component>

